import { IconDefinition, SizeProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface Props {
    icon: IconDefinition;
    size?: SizeProp;
    title?: string;
    iconClassName?: string;
    children?: React.ReactNode;
}

export const Icon = ({
    icon,
    size,
    title,
    children,
    iconClassName,
}: Props): React.ReactElement<any, any> | null => (
    <>
        <FontAwesomeIcon title={title} icon={icon} size={size} className={iconClassName} />
        {children && (
            <span className="ml-2" title={title}>
                {children}
            </span>
        )}
    </>
);
